import React from 'react';
import { createFdIcon } from './createFdIcon';

// Additional universal concepts needed to cover the full MUI usage surface.
// Same Bare Knuckle construction spec.

export const HomeIcon = createFdIcon(
  <>
    <polyline points="4,11 12,4 20,11" />
    <polyline points="6,10 6,20 18,20 18,10" />
  </>,
  'HomeIcon'
);

export const MenuIcon = createFdIcon(
  <>
    <line x1="4" y1="7" x2="20" y2="7" />
    <line x1="4" y1="12" x2="20" y2="12" />
    <line x1="4" y1="17" x2="20" y2="17" />
  </>,
  'MenuIcon'
);

export const SaveIcon = createFdIcon(
  <>
    <path d="M4 4 H16 L20 8 V20 H4 Z" />
    <rect x="8" y="4" width="6" height="5" />
    <rect x="7" y="13" width="10" height="7" />
  </>,
  'SaveIcon'
);

export const LinkIcon = createFdIcon(
  <>
    <line x1="9" y1="15" x2="15" y2="9" />
    <path d="M8 13 L6 15 A3 3 0 0 0 9 18 L11 16" />
    <path d="M16 11 L18 9 A3 3 0 0 0 15 6 L13 8" />
  </>,
  'LinkIcon'
);

export const PhoneIcon = createFdIcon(
  <>
    <rect x="7" y="3" width="10" height="18" />
    <line x1="10" y1="18" x2="14" y2="18" />
  </>,
  'PhoneIcon'
);

export const BookmarkIcon = createFdIcon(
  <path d="M6 3 H18 V21 L12 16 L6 21 Z" />,
  'BookmarkIcon'
);

export const PlayIcon = createFdIcon(
  <polygon points="7,4 20,12 7,20" />,
  'PlayIcon'
);

export const StopIcon = createFdIcon(
  <rect x="6" y="6" width="12" height="12" />,
  'StopIcon'
);

export const LanguageIcon = createFdIcon(
  <>
    <circle cx="12" cy="12" r="9" />
    <ellipse cx="12" cy="12" rx="4" ry="9" />
    <line x1="3" y1="12" x2="21" y2="12" />
  </>,
  'LanguageIcon'
);

export const CopyIcon = createFdIcon(
  <>
    <rect x="8" y="8" width="12" height="12" />
    <polyline points="16,8 16,4 4,4 4,16 8,16" />
  </>,
  'CopyIcon'
);

export const ImageIcon = createFdIcon(
  <>
    <rect x="3" y="4" width="18" height="16" />
    <circle cx="8" cy="9" r="1.5" />
    <polyline points="5,18 10,12 14,16 17,13 21,17" />
  </>,
  'ImageIcon'
);

export const FolderIcon = createFdIcon(
  <path d="M3 6 H9 L11 9 H21 V19 H3 Z" />,
  'FolderIcon'
);

export const SwapIcon = createFdIcon(
  <>
    <polyline points="7,4 3,8 7,12" />
    <line x1="3" y1="8" x2="20" y2="8" />
    <polyline points="17,12 21,16 17,20" />
    <line x1="21" y1="16" x2="4" y2="16" />
  </>,
  'SwapIcon'
);

export const DeviceIcon = createFdIcon(
  <>
    <rect x="4" y="4" width="16" height="12" />
    <line x1="2" y1="20" x2="22" y2="20" />
  </>,
  'DeviceIcon'
);

// Checkbox glyphs for the MUI Checkbox theme slot (hard square, no radius).
export const CheckboxBlankIcon = createFdIcon(
  <rect x="4" y="4" width="16" height="16" />,
  'CheckboxBlankIcon'
);

export const CheckboxCheckedIcon = createFdIcon(
  <>
    <rect x="4" y="4" width="16" height="16" />
    <polyline points="8,12 11,15 16,9" />
  </>,
  'CheckboxCheckedIcon'
);
